<template>
  <b-modal
    ref="modal"
    centered
    id="review-modal"
    modal-class="text-dark"
    :visible="userReviewModalVisibility"
    hide-footer
    @hidden="hideUserReviewModal"
  >
    <!-- <VueStars
      class="star-rate d-flex align-items-center"
      name="rate"
      :readonly="false"
      :value="review.rate"
      @input="updateRate"
    /> -->
    <div class="d-flex flex-row align-items-center mb-2">
    <h6 class="mb-0">
      {{$t('UserReview.UserRate')}}
    </h6>
    <StarRating 
      :max-rating="5" 
      :star-size="25" 
      :border-width="0"
      :show-rating="false"
      :rating="userProductRate ? userProductRate.ratePoint:0"
      class="star-rate d-flex align-items-center mx-2 mb-1"
        @rating-selected="updateRate"/>
        </div>
    <textarea v-model="review.description" rows="5" class="col-12" />
    <div class="d-flex justify-content-end">
      <b-button class="px-3 m-2" variant="success" @click="submitReview">
        {{ $t('UserReview.SubmitComment') }}
      </b-button>
      <b-button class="px-3 m-2" variant="danger" @click="close">
        {{ $t('UserReview.Cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import VueStars from '@/components/VueStars.vue'
import StarRating from 'vue-star-rating'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserReviewModal',
  components: {
    VueStars,
    StarRating
  },
  computed: {
    ...mapGetters({
      userReviewModalVisibility: 'userReview/userReviewModalVisibility'
    })
  },
  props: {
    review: Object,
    userProductRate: Object
  },
  methods: {
    ...mapActions({
      hideUserReviewModal: 'userReview/hideUserReviewModal'
    }),
    submitReview () {
      this.$emit('submitReview', this.review)
    },
    close () {
      this.$refs.modal.hide()
    },
    updateRate (rate) {
      this.review.rate = rate
    }
  },
  mounted () {
    this.review.description = ''
  },
  created () {
    this.review.description = ''
  }
}
</script>
